module.exports = __webpack_public_path__ + "ef24910c5aa1b51ba8d6bbb95e641569.svg";